import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  Collapsible,
  ColorPicker,
  Layout,
  BlockStack,
  TextField,
  InlineStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const Heading = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, HEADING, DEFAULT_HEADING_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.headingColor.title")}
        description={cms("section.headingColor.description")}
      >
        <Card
          title={[
            cms("section.headingColor.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.headingColor.subDescription")}</BlockStack>
            <br />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack>
                  <TextField
                    label={cms("section.headingColor.label.hexCode")}
                    value={hex.headingHex}
                    onChange={(value) => handleChange(HEADING, value, HEX)}
                    labelAction={
                      hex.headingHex !== DEFAULT_HEADING_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(HEADING, DEFAULT_HEADING_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.heading}
                  />
                  <br />
                  <Text as="span" variant="bodySm">
                    <div
                      style={{
                        borderRadius: ".5rem",
                        width: "max-content",
                        height: "28px",
                        color: hex.headingHex,
                        textAlign: "center",
                        padding: "6px 12px",
                      }}
                    >
                      {cms("section.headingColor.label.sampleHeader")}
                    </div>
                  </Text>
                </BlockStack>
              </Box>
              <ColorPicker onChange={(value) => handleChange(HEADING, value, COLOR)} color={color.headingColor} />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(Heading);
